module.exports = __webpack_public_path__ + "img/16.410be9c8.png";